module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-layout', {
    staticClass: "ql-pages-container",
    staticStyle: {
      "overflow": "auto",
      "scroll-behavior": "smooth"
    }
  }, [_c('md-layout', {
    staticClass: "ql-page-layout ql-thumbail-view",
    attrs: {
      "md-row": "",
      "md-gutter": "12"
    }
  }, _vm._l((_vm.visiblePages), function(pageIdx) {
    return _c('project-thumbnail-page', {
      key: pageIdx,
      staticClass: "md-flex",
      class: {
        'selected-page-number': _vm.isSelected(pageIdx)
      },
      attrs: {
        "data-thumb-page": pageIdx,
        "pageIndex": pageIdx,
        "page": _vm.currentProjectPage(pageIdx),
        "locked": _vm.locked,
        "showMode": _vm.showMode,
        "issrc": _vm.project.issrc
      },
      on: {
        "click": function($event) {
          return _vm.handlePageClick(pageIdx)
        },
        "thumbnailSelectionClick": _vm.thumbnailSelectionClick,
        "pageLoaded": _vm.pageLoaded
      }
    })
  }), 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7e9f1f40","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/project/thumbnail-pages.vue
// module id = 1270
// module chunks = 21